import {
	requests
}from "../../../../api/agent"

export default {
	getList                      : (params) => requests.getWithParams('/reConstructionMaterial/getList', params),
	getHierarchy                 : (params) => requests.getWithParams('/reConstructionMaterial/getHierarchy', params),
	getPaged                     : (params) => requests.getWithParams('/reConstructionMaterial/getPaged', params),
	getPagedAll                  : (params) => requests.getWithParams('/reConstructionMaterial/getPagedAll', params),
	getPagedAudit                : (params) => requests.getWithParams('/reConstructionMaterial/getPagedAudit', params),
	getMaterialOrgPriceInfoPaged : (params) => requests.getWithParams('/reConstructionMaterial/getMaterialOrgPriceInfoPaged', params),
	create                       : (params) => requests.post('/reConstructionMaterial/create', params),
	delete                       : (params) => requests.getWithParams('/reConstructionMaterial/delete', params),
	update                       : (params) => requests.post('/reConstructionMaterial/update', params),
	restore                      : (params) => requests.getWithParams('/reConstructionMaterial/restore', params),
	getCharacteristicsFile       : (params) => requests.postFile('/reConstructionMaterial/getCharacteristicsFile', params),
	updateClassifier             : (params) => requests.post('/reConstructionMaterial/updateClassifier', params),
	getExampleFile               : () => requests.getFile('/reConstructionMaterial/getExampleFile')
}